import React from "react";
import { Helmet } from 'react-helmet-async';
import "./Gamecommon.css";
import GameHeroSection from "./GameHeroSection/GameHeroSection";
import GameCounter from "./gamecounter/GameCounter";
import GameIdeas from "./gameideas/GameIdeas";
import GameChoose from "./gamechoose/GameChoose";
import GameBuild from "./gamebuild/GameBuild";
import GameIndustry from "./gameindustry/GameIndustry";
import GameServices from "./gameservices/Services";

export default function GameDev() {
  return (
    <div>
      <Helmet>
        <title>Game Development Services | Expert Game Development Company</title>
        <meta name="description" content="Professional game development company specializing in Unity and blockchain games. Build engaging, high-quality gaming experiences with NFT integration." />
        <link rel="canonical" href="https://bastionex.net/game-development" />
      </Helmet>
      <GameHeroSection />
      <GameCounter/>
      <GameIdeas />
        <GameChoose />
        <GameBuild/>
     <GameIndustry/>
     <GameServices/>
    </div>
  );
}
